/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccordionItemsQueryVariables = Types.Exact<{
  location: Types.AccordionLocation;
  council?: Types.InputMaybe<Types.CouncilsListFilter>;
}>;


export type AccordionItemsQuery = { __typename?: 'Query', council?: Array<{ __typename?: 'AccordionItem', id: string, location: Types.AccordionLocation, title: string, content: string, itemOrder: number, isExpanded?: boolean | null, userType: Types.AccordionUserType } | null> | null, all?: Array<{ __typename?: 'AccordionItem', id: string, location: Types.AccordionLocation, title: string, content: string, itemOrder: number, isExpanded?: boolean | null, userType: Types.AccordionUserType } | null> | null };


export const AccordionItemsDocument = gql`
    query accordionItems($location: AccordionLocation!, $council: CouncilsListFilter) {
  council: accordionItems(
    filter: {location: $location, council: $council}
    pagination: {orderBy: {itemOrder: ASC}}
  ) {
    id
    location
    title
    content
    itemOrder
    isExpanded
    userType
  }
  all: accordionItems(
    filter: {location: $location, council: {id_null: true}}
    pagination: {orderBy: {itemOrder: ASC}}
  ) {
    id
    location
    title
    content
    itemOrder
    isExpanded
    userType
  }
}
    `;

/**
 * __useAccordionItemsQuery__
 *
 * To run a query within a React component, call `useAccordionItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccordionItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccordionItemsQuery({
 *   variables: {
 *      location: // value for 'location'
 *      council: // value for 'council'
 *   },
 * });
 */
export function useAccordionItemsQuery(baseOptions: Apollo.QueryHookOptions<AccordionItemsQuery, AccordionItemsQueryVariables> & ({ variables: AccordionItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccordionItemsQuery, AccordionItemsQueryVariables>(AccordionItemsDocument, options);
      }
export function useAccordionItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccordionItemsQuery, AccordionItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccordionItemsQuery, AccordionItemsQueryVariables>(AccordionItemsDocument, options);
        }
export function useAccordionItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccordionItemsQuery, AccordionItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccordionItemsQuery, AccordionItemsQueryVariables>(AccordionItemsDocument, options);
        }
export type AccordionItemsQueryHookResult = ReturnType<typeof useAccordionItemsQuery>;
export type AccordionItemsLazyQueryHookResult = ReturnType<typeof useAccordionItemsLazyQuery>;
export type AccordionItemsSuspenseQueryHookResult = ReturnType<typeof useAccordionItemsSuspenseQuery>;
export type AccordionItemsQueryResult = Apollo.QueryResult<AccordionItemsQuery, AccordionItemsQueryVariables>;